import { AuditViewDto } from './../../../../service/dto';
import { Component, Input } from '@angular/core';
import { AgentDto, AuditSessionDto, ResultListDto } from '../../../../service/dto';
import { HttpAuditService } from '../../../../service/http-audit.service';
import { OnTableChange, TableColumn } from '../../../../components/table/table.component';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-agent-audit-views',
	standalone: false,
	templateUrl: './agent-audit-views.component.html',
	styleUrl: './agent-audit-views.component.scss'
})
export class AgentAuditViewsComponent {
	_agent!: AgentDto;
	selectedTabIndex = 0;
	resultsByAgent!: ResultListDto<AuditViewDto>;
	resultsOfAgent!: ResultListDto<AuditViewDto>;

	loading = false;
	columnRefByAgent: TableColumn[] = [
		{ "title": "Date", "cellRef": "date", exportValue: item => `${item.date}`  },
		{ "title": "Type", "property": "recordType" },
		{ "title": "Description", "property": "recordLabel" },
		{ "title": "Action", "cellRef": "action" }
	];
	columnRefOfAgent: TableColumn[] = [
		{ "title": "Date", "cellRef": "date" },
		{"title":"Viewed By", property: "viewedBy.username"}
	];

	constructor(private service: HttpAuditService) {

	}

	@Input('agent')
	set agent(input: AgentDto) {
		this._agent = input;
		this.loading = true;
		this.service.getAgentsViewHistory(this._agent.id, 0, 50)
			.pipe(finalize(() => this.loading = false))
			.subscribe(results => {
				this.resultsByAgent = results;
			})
	}

	get agent(): AgentDto {
		return this._agent;
	}

	trackByHashCode(index: number, item: AuditSessionDto): any {
		return item.hashCode;
	}

	doFetchResultsByAgent(input: OnTableChange) {
		this.loading = true;
		this.service.getAgentsViewHistory(this._agent.id, input.pageIndex, input.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.resultsOfAgent = result;
			});
	}
	doFetchResultsOfAgent(input: OnTableChange) {
		this.loading = true;
		this.service.getViewHistoryOfAgent(this._agent.id, input.pageIndex, input.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.resultsOfAgent = result;
			});
	}
}

